import React from 'react'
import styled from 'styled-components'
import media from '../../../styles/media'
import shortid from 'shortid'

import Rectangle from '../../text/rectangle'

const BusinessContainer = styled.div``

const BusinessWrapper = styled.div``

const Title = styled.h3`
  font-weight: 600;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.25;
  letter-spacing: normal;
  text-align: center;
  color: #3c4252;
  margin: 0px 0px 30px 0px;
`

const RectangleWrapper = styled.div`
  margin-bottom: 2rem;
`

const Business = props => {
  const { business, prevTitle } = props

  const rectangles = business.map(item => (
    <RectangleWrapper className="col-12 col-md" key={shortid.generate()}>
      <Rectangle title={item.title} text={item.text} />
    </RectangleWrapper>
  ))
  return (
    <BusinessContainer {...props}>
      <Title>
        {prevTitle !== '' ? prevTitle : 'Nuestros modelos de negocio'}
      </Title>
      <BusinessWrapper className="row">{rectangles}</BusinessWrapper>
    </BusinessContainer>
  )
}

export default Business



// WEBPACK FOOTER //
// ./src/components/section/business/business.js